import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import FormComponent from "../components/FormComponent";
import { getEventById } from "../api/events";
import { useMatch, useParams } from "react-router-dom";
import { getRepoEventById } from "../api/repo-events";

const Main = () => {
    const [event, setEvent] = useState(null);
    const [loadingEvent, setLoadingEvent] = useState(false);
    const [isConfirmation, setConfirmation] = useState(false);
    const { id } = useParams();
    const isRepoEvent = useMatch("/evento/repo/:id");

    useEffect(() => {
        event === null && handleEvent();
        // eslint-disable-next-line
    }, [event]);

    const handleEvent = async () => {
        setLoadingEvent(true);
        try {
            const res = isRepoEvent ? await getRepoEventById(id) : await getEventById(id);
            setEvent(res);
            setLoadingEvent(false);
        } catch (error) {
            setEvent(false);
            setLoadingEvent(false);
        }
    };

    useEffect(() => {
        window.addEventListener("confirmEvent", () => setConfirmation(true));
        return () => {
            window.removeEventListener("confirmEvent", () => setConfirmation(true));
        }
    }, [])

    const onDate = !(new Date() < new Date(event?.date_begin + 'Z'));

    return (
        <Container isConfirmation={isConfirmation && !!isRepoEvent}>
            {loadingEvent ? (
                <p>Cargando información del evento...</p>
            ) : onDate ? (
                <>
                    { !(isConfirmation && isRepoEvent) && <Header>¡Marca tu asistencia!</Header>}
                    <Body>
                        { !(isConfirmation && isRepoEvent) && <><p>EVENTO</p>
                        <h3>
                            {event?.publication_name
                                ? event?.publication_name
                                : "EVENTO NO IDENTIFICADO"}
                        </h3></>}
                        { event && <FormComponent id={id} event={event} /> }
                    </Body>
                </>
            ): (
                <>
                    <Header>¡Marca tu asistencia!</Header>
                    <Body>
                        <p>EVENTO</p>
                        <h3>
                            {event?.publication_name}
                        </h3>
                        <h4>Debes esperar a que inicie el evento para poder marcar tu asistencia.</h4>
                    </Body>
                </>
            )}
        </Container>
    );
};

export default Main;

const Container = styled.div`
    width: ${(p) => (p.isConfirmation ? "100%" : "500px")};
    max-width: ${(p) => (p.isConfirmation ? "1200px" : "500px")};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;

    @media (max-width: 550px) {
        width: ${(p) => (p.isConfirmation ? "100%" : "90%")};
        padding: 0 1rem;
    }
`;

const Header = styled.div`
    width: 100%;
    background-color: #b31d15;
    color: #fff;
    font-size: 1.3rem;
    padding: 2px;
    font-weight: bold;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "PT Serif", serif;
    font-style: italic;
`;

const Body = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    align-items: center;

    p {
        color: #535353;
        font-size: 1.3rem;
    }

    h3 {
        color: #cd2118;
        font-size: 1.5rem;
        text-align: center;
    }

    h4 {
        color: #1d1d1b;
        font-size: 1.2rem;
        text-align: center;
    }
`;
